module.exports = __webpack_public_path__ + "img/review-success-zhant.1f9f1c58.png";